"use client"

import { useState } from "react"
import Modal from "./Modal"
import "../styles/Overview.css"
import overviewbg from "../assets/images/overview.png"
import overview1 from "../assets/images/O_women.jpg"
import overview2 from "../assets/images/O_car.jpg"
// import overview3 from "../assets/images/O_garden.jpg"

export default function Overview() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <section className="overview" style={{ backgroundImage: `url(${overviewbg})` }}>
        <div className="overview-container">
          <div className="overview-left">
            <h3 className="section-label">OVERVIEW</h3>
            <h2 className="section-title">Ashtech Presidential Towers</h2>

            <p className="overview-text">
              Ashtech Presidential Towers brings an exclusive residential project in Sector 12, Greater Noida West, offering premium 3 and 4 BHK luxury apartments that represent the best of modern living. Designed for families who value space, comfort, and style, this project combines elegant architecture with top-class amenities and a prime location.
            </p>

            <p className="overview-text">
              Each home is built with careful attention to detail, featuring modern layouts, spacious balconies, and well-ventilated interiors that fill rooms with natural light. The apartments come with high-quality fittings and premium finishes, offering a perfect balance of comfort and elegance. The 3 BHK flats are ideal for small families looking for stylish and practical living spaces, while the 4 BHK apartments offer larger families the luxury of extra space and privacy.
            </p>

            <button className="download" onClick={() => setIsModalOpen(true)}>
              DOWNLOAD BROCHURE
            </button>
          </div>

          <div className="overview-right">
            <div className="image-grid">
              <img src={`${overview1}`} alt="Overview 1" className="img-1" />
              <img src={`${overview2}`} alt="Overview 2" className="img-2" />
              {/* <img src={`${overview3}`} alt="Overview 3" className="img-3" /> */}
            </div>
          </div>
        </div>
      </section>

      <div className="overview-stats">
        <div className="overview-card">
          <h4>3 Acres</h4>
          <p>CENTRAL PARK</p>
        </div>
        <div className="overview-card">
          <h4>70,000 Sq Ft</h4>
          <p>BIGGEST CLUB HOUSE</p>
        </div>
        <div className="overview-card">
          <h4>5</h4>
          <p>HIGH SPEED LIFTS</p>
        </div>
        <div className="overview-card">
          <h4>12 ft</h4>
          <p>CEILING HEIGHT</p>
        </div>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
